import { atom } from 'jotai';
import { $ExperienceGPTAnswer } from 'shared/atoms';
import { ExperienceGPTAnswer, UnavailableExperienceData, ExperienceUtil } from 'shared/models';
import { $CurrentExperienceKeyword } from './current-experience-keyword';

export const $CurrentExperienceAnswer = atom<Promise<ExperienceGPTAnswer | UnavailableExperienceData>>((get) => {
  const keyword = get($CurrentExperienceKeyword);

  return get($ExperienceGPTAnswer(keyword));
});

export const $CurrentAvailableExperienceDataOrNull = atom<Promise<ExperienceGPTAnswer | null>>(async (get) => {
  const keyword = get($CurrentExperienceKeyword);

  const data = await get($ExperienceGPTAnswer(keyword));
  if (ExperienceUtil.isExperienceDataAvailable(data)) {
    return data;
  }

  return null;
});

export const $CurrentExperienceAnswerAsAvailable = atom<Promise<ExperienceGPTAnswer>>((get) => {
  const keyword = get($CurrentExperienceKeyword);

  return get($ExperienceGPTAnswer(keyword)) as Promise<ExperienceGPTAnswer>;
});
